export default __webpack_public_path__ + "static/media/empty_projects.35cc851d.png";